<div id="creative" class="py-5">
    <div class="container" style="padding-right: 0px;">
        <div class="row">
            <div class="col-lg-6 col-md-4 col-sm-12 height650" >
                <div class="corner">
                    <div class="heading">
                        <h2>CREATIVE CORNER</h2>
                        <hr>
                    </div>
                    <div class="sub-head">
                        <hr class="part1">
                        <p>Here's the latest from R.P.D.A.V Public School</p>
                        <hr class="part2">
                    </div>
                </div>
                <div class="showcase" style="padding-bottom: 20px;">
                    <div class="carousel slide" id="slide3" data-ride="carousel">
                        <!-- Indicator -->
                        <ol class="carousel-indicators">
                            <li class="active" data-target="#slide3"
                            data-slide-to="0"></li>
                            <li data-target="#slide3" data-slide-to="1"></li>
                            <li data-target="#slide3" data-slide-to="2"></li>
                        </ol>
                        <!-- img URL -->
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <a href="/assets/img/creative/1.jpeg" data-lightbox="Creative Corner"> <img appLazyload src="/assets/img/creative/1.jpeg" alt="School Building" class="d-block img-fluid rounded"></a>
                            </div>
                            <div class="carousel-item ">
                                <a href="/assets/img/creative/2.jpeg" data-lightbox="Creative Corner"> <img appLazyload src="/assets/img/creative/2.jpeg" alt="Skating" class="d-block img-fluid rounded"></a>
                            </div>
                            <div class="carousel-item">
                                <a href="/assets/img/creative/2.jpeg" data-lightbox="Creative Corner"> <img appLazyload src="/assets/img/creative/3.jpeg" alt="Playing Games" class="d-block img-fluid rounded"></a>
                               
                            </div>
                        </div>
                        <!-- controller -->
                        <a href="#slide3" class="carousel-control-prev"
                        data-slide="prev">
                            <span class="carousel-control-prev-icon"></span>
                        </a>
                        <a href="#slide3" class="carousel-control-next"
                        data-slide="next">
                            <span class="carousel-control-next-icon"></span>
                        </a>
                    </div>
                    
                </div>
            </div>
            <div class="col-lg-6 col-md-4 col-sm-12 height650"  >
                <div class="corner">
                    <div class="heading">
                        <h2 style="flex-basis: 56%;">CURRENT ACTIVITIES</h2>
                        <hr style="flex-basis: 42%;">
                    </div>
                    <div class="sub-head">
                        <hr class="part1">
                        <p class="part4">Here's the latest about VIRTUAL Activities</p>
                        <hr class="part3">
                    </div>
                </div>
                <div class="showcase" style="padding-bottom: 20px;">
                    <div class="carousel slide" id="slide4" data-ride="carousel" >
                        <!-- Indicator -->
                        <ol class="carousel-indicators">
                            <li class="active" data-target="#slide4"
                            data-slide-to="0"></li>
                            <li data-target="#slide4" data-slide-to="1"></li>
                            <li data-target="#slide4" data-slide-to="2"></li>
                            <li data-target="#slide4" data-slide-to="3"></li>
                            <li data-target="#slide4" data-slide-to="4"></li>
                        </ol>
                        <!-- img appLazyload URL -->
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <a href="/assets/img/creative/activities/1.jpeg" data-lightbox="Current Activities"> <img appLazyload src="/assets/img/creative/activities/1.jpeg" alt="School Building" class="d-block img-fluid rounded"></a>
                            </div>
                            <div class="carousel-item ">
                               <a href="/assets/img/creative/activities/2.jpeg" data-lightbox="Current Activities"> <img appLazyload src="/assets/img/creative/activities/2.jpeg" alt="School Building" class="d-block img-fluid rounded"></a>
                            </div>
                            <div class="carousel-item ">
                                <a href="/assets/img/creative/activities/3.jpeg" data-lightbox="Current Activities"> <img appLazyload src="/assets/img/creative/activities/3.jpeg" alt="School Building" class="d-block img-fluid rounded"></a>
                             </div>
                             <div class="carousel-item ">
                                <a href="/assets/img/creative/activities/4.jpeg" data-lightbox="Current Activities"> <img appLazyload src="/assets/img/creative/activities/4.jpeg" alt="School Building" class="d-block img-fluid rounded"></a>
                             </div>
                             <div class="carousel-item ">
                                <a href="/assets/img/creative/activities/5.jpeg" data-lightbox="Current Activities"> <img appLazyload src="/assets/img/creative/activities/5.jpeg" alt="School Building" class="d-block img-fluid rounded"></a>
                             </div>
                        </div>
                        <!-- controller -->
                        <a href="#slide4" class="carousel-control-prev"
                        data-slide="prev">
                            <span class="carousel-control-prev-icon"></span>
                        </a>
                        <a href="#slide4" class="carousel-control-next"
                        data-slide="next">
                            <span class="carousel-control-next-icon"></span>
                        </a>
                    </div>
                    
                </div>
            </div>
    
    </div>
</div>
